"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11.063 3.61a1.5 1.5 0 0 1 1.874 0l6.125 4.9A2.5 2.5 0 0 1 20 10.46v9.04a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5V17a2 2 0 1 0-4 0v2.5A1.5 1.5 0 0 1 8.5 21h-3A1.5 1.5 0 0 1 4 19.5v-9.039a2.5 2.5 0 0 1 .938-1.952zm1.25.78a.5.5 0 0 0-.625 0l-6.125 4.9A1.5 1.5 0 0 0 5 10.461V19.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V17a3 3 0 0 1 6 0v2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-9.039a1.5 1.5 0 0 0-.563-1.171z"
}), 'Home');
//# sourceMappingURL=index.js.map